import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface ReadonlyFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function ReadonlyField({ field, value, error }: ReadonlyFieldProps) {
  const displayValue = field.readonly_value ?? value ?? '-'

  return (
    <FieldWrapper field={field} error={error}>
      <div
        className="w-full px-2 py-1.5 text-sm border rounded"
        style={{
          backgroundColor: 'var(--color-bg-tertiary, #f5f5f5)',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-secondary)',
        }}
      >
        {String(displayValue)}
      </div>
    </FieldWrapper>
  )
}
